import React from 'react';
import { Button, Container, Image, Stack } from 'react-bootstrap';
import { IMAGE_PATHS } from 'constants/imagePaths';
import parse from 'html-react-parser';
import useTranslate from 'hooks/useTranslate';
import SearchJobs from 'components/Common/Jobs/SearchJobs';
import useAuthStore from 'store/auth';
import { USER_TYPES, APP_STORE, PLAY_STORE } from 'constants';
import './styles.scss';

const Banner: React.FC = () => {
	const { translate } = useTranslate();
	const { user, token }: Record<string, any> = useAuthStore((state) => state.userInfo ?? {});
	return (
		<section className="banner bg-white">
			<Container>
				<Stack className="banner-inner align-items-center justify-content-center">
					<div className="banner-inner-heading">
						<h1>{parse(translate('Home.bannerTitle'))}</h1>
						{/* <p className="mb-0">{translate('Home.bannerSubTitle')}</p> */}
					</div>
					<div className="get-app-buttons d-flex gap-2 gap-md-3">
						<Button
							className="bg-white"
							onClick={() => window.open(PLAY_STORE)}
							target="_blank"
							rel="noopener noreferrer"
						>
							<Image
								src={IMAGE_PATHS.GooglePlayIcon}
								className="h-100 w-100 object-fit-contain"
								alt="googlePlayIcon"
								loading="lazy"
							/>
						</Button>
						<Button
							className="bg-white"
							onClick={() => window.open(APP_STORE)}
							target="_blank"
							rel="noopener noreferrer"
						>
							<Image
								src={IMAGE_PATHS.AppStoreIcon}
								className="h-100 w-100 object-fit-contain"
								alt="appStoreIcon"
								loading="lazy"
							/>
						</Button>
						<Button className="bg-white">
							<Image
								src={IMAGE_PATHS.AwsIcon}
								className="h-100 w-100"
								style={{ objectFit: 'contain' }}
								alt="aws-icon"
								loading="lazy"
							/>
						</Button>
					</div>
					{user?.userType === USER_TYPES.SEEKER && token && (
						<div className="banner-filters w-100">
							<SearchJobs />
						</div>
					)}
				</Stack>
			</Container>
		</section>
	);
};

export default Banner;
